import { api, API } from "@/lib/api";
import { toast } from "sonner";

const VAPID_PUBLIC = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function isWebPushSupported() {
  return typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window;
}

export async function getWebPushPermission() {
  if (!isWebPushSupported()) return "unsupported";
  return Notification.permission;
}

export async function ensureWebPushSubscribed() {
  if (!isWebPushSupported() || !VAPID_PUBLIC) return { ok: false, reason: "unsupported" };
  if (Notification.permission === "denied") return { ok: false, reason: "denied" };

  if (Notification.permission !== "granted") {
    const p = await Notification.requestPermission();
    if (p !== "granted") return { ok: false, reason: "denied" };
  }
  let reg;
  try {
    reg = await navigator.serviceWorker.register("/sw.js");
    await navigator.serviceWorker.ready;
  } catch (e) {
    return { ok: false, reason: "sw_register_failed", error: String(e) };
  }
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    try {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC),
      });
    } catch (e) {
      return { ok: false, reason: "subscribe_failed", error: String(e) };
    }
  }
  const subJson = sub.toJSON();
  try {
    await api.post("/push/subscribe", {
      endpoint: subJson.endpoint,
      keys: { p256dh: subJson.keys.p256dh, auth: subJson.keys.auth },
      user_agent: navigator.userAgent,
    });
  } catch (e) {
    return { ok: false, reason: "server_save_failed", error: String(e) };
  }
  return { ok: true, endpoint: subJson.endpoint };
}

export async function unsubscribeWebPush() {
  if (!isWebPushSupported()) return;
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try { await api.delete("/push/subscribe", { data: { endpoint: sub.endpoint } }); } catch { /* noop */ }
    await sub.unsubscribe();
  }
}

export async function sendTestPush() {
  try {
    const r = await api.post("/push/test");
    toast.success(`Test push sent (${r.data.sent} device${r.data.sent === 1 ? "" : "s"})`);
  } catch (e) {
    toast.error("Test push failed");
  }
}
